// Our own fraud check, run while the pre-lander shows (?prelander=1). It does not ask Evina: a /check
// before the JOIN tap fixes that transaction's verdict at 2802 for good, so Evina's real verdict (ours
// after the tap, and Telkom's) would block every genuine visitor. Only signals a real phone never shows
// block here; anything subtler is left to Evina at the tap.
const MOBILE_UA = /Android|iPhone|iPad|iPod/i
// A desktop's navigator.platform under a phone user agent is what Chrome's device emulation leaves
// behind (Evina scores those 2401). Phones report "Linux armv8l" / "Linux aarch64" / "iPhone".
const DESKTOP_PLATFORM = /^(Win|Mac|Linux x86_64|Linux i686)/i
// Desktop or software GPUs; phones report Adreno, Mali, PowerVR, Apple GPU, Xclipse, Immortalis.
const DESKTOP_GPU = /Direct3D|D3D1[01]|GeForce|Quadro|Radeon (RX|Pro)|Intel\(R\) (UHD|Iris|HD)|SwiftShader|llvmpipe/i

function gpuRenderer() {
  try {
    const gl = document.createElement('canvas').getContext('webgl')
    const info = gl && gl.getExtension('WEBGL_debug_renderer_info')
    const renderer = info ? String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL) || '') : ''
    gl?.getExtension('WEBGL_lose_context')?.loseContext()
    return renderer
  } catch {
    return ''
  }
}

function framed() {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

/**
 * @returns {{blocked: boolean, reasons: string[]}} reasons: webdriver, headless, framed,
 *   platform_mismatch, desktop_gpu
 */
export default function riskCheck() {
  const ua = navigator.userAgent || ''
  const reasons = []
  if (navigator.webdriver === true) reasons.push('webdriver')
  if (/Headless/i.test(ua)) reasons.push('headless')
  if (framed()) reasons.push('framed')
  if (MOBILE_UA.test(ua)) {
    if (DESKTOP_PLATFORM.test(navigator.platform || '')) reasons.push('platform_mismatch')
    if (DESKTOP_GPU.test(gpuRenderer())) reasons.push('desktop_gpu')
  }
  return { blocked: reasons.length > 0, reasons }
}
